module.exports = function getResource(label, vars = []) {
    const resources = {
        status: 'Status',
        seeTrackingDetails: 'See tracking details',
        shippingMethod: 'Shipping Method',
        estimatedDelivery: 'Estimated Delivery',
        tracking: 'Tracking #',
        deliverTo: 'Deliver To',
        billingInfo: 'Billing Info',
        paypalAccount: 'PayPal Account',
        applePay: 'Apple Pay',
        shipment: 'SHIPMENT',
        needToReturnSomething: 'Need to return something?',
        changedYourMind: 'Changed your mind?',
        cancelYourOrder: 'Cancel your order',
        paidWith: 'Paid with ',
        shipTo: 'Ship To'
    };

    return resources[label];
};
